<script setup>
// 快捷方块数据
const props = defineProps({
  quick: {
    type: Array,
    default: () => [],
  },
})

// 只取前 5 个，避免模板渲染全部数据
const quickList = computed(() => {
  return Array.isArray(props.quick) ? props.quick.slice(0, 5) : []
})
</script>

<template>
    <!-- 快捷方块2 -->
    <div class="Heziyun-blockBackground">
        <div class="Heziyun-quick2">
            <a 
                v-for="(item, index) in quickList"
                :key="item.id || index"
                :href="item.url"
                class="Heziyun-itemBlock"
                v-intersect="{ class: 'bottom-top', delay: index * 40 }"
            >
                <div class="Heziyun-neirong">
                    <div class="Heziyun-picture">
                        <a-image :src="item.img" :show-loader="true" :preview="false" />
                        <span>{{ item.title }}</span>
                    </div>
                    <div class="Heziyun-text">
                        <p>{{ item.tips }}</p>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>

<style lang="less" scoped>
// 快捷方块2 
.Heziyun-blockBackground {
    background-color: #fff;
    height: 0;

    .Heziyun-quick2 {
        width: 100%;
        margin: 0 auto;
        position: relative;
        top: -3rem;
        z-index: 10;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        gap: 1rem;
        flex-wrap: wrap;
        height: 13%;

        .Heziyun-itemBlock {
            width: 16rem;
            overflow: hidden;
            position: relative;
            box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, .1);
            background-image: linear-gradient(0deg, #fff, #f3f5f8);
            border: 2px solid #fff;
            border-radius: 4px;

            .Heziyun-neirong {
                position: relative;
                padding: 1rem;
                display: flex;
                flex-direction: column;
                gap: 0.5rem;

                &:hover {
                    .Heziyun-picture {
                        span {
                            color: #0052d9;
                        }
                    }
                }

                .Heziyun-picture {
                    flex-shrink: 0;
                    border-radius: 0.5rem;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    :deep(.arco-image) {
                        width: auto;
                    }
                    :deep(.arco-image-img) {
                        width: 1.8rem;
                        height: 1.8rem;
                        object-fit: contain;
                    }

                    span {
                        color: #111827;
                        font-size: 0.95rem;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }

                .Heziyun-text {

                    p {
                        color: #4b5b76;
                        font-size: 0.8rem;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }

    }
}

@media (max-width: 768px) {

    .Heziyun-blockBackground {
        height: auto;

        // 快捷方块2 
        .Heziyun-quick2 {
            margin: 0;
            position: initial;
            gap: 3vw;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            padding: 5vw;
            background-color: #f3f5f8;
            height: auto;

            .Heziyun-itemBlock {
                width: 100%;
                background-color: rgba(228, 238, 255, 0.43);
                background-image: linear-gradient(0deg, #fff, #f3f5f8);
                border: 2px solid #fff;
                box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, .1);
                border-radius: 1vw;
                font-family: "思源黑";

                .Heziyun-neirong {
                    padding: 3vw;
                    gap: 2vw;

                    .Heziyun-picture {
                        gap: 2vw;

                        :deep(.arco-image-img) {
                            width: 7vw;
                            height: 7vw;
                        }

                        span {
                            font-size: 4vw;
                        }
                    }

                    .Heziyun-text {

                        p {
                            font-size: 3.5vw;
                            -webkit-line-clamp: 1;
                        }
                    }
                }
            }

        }

        .Heziyun-quick2> :last-child:nth-child(odd) {
            grid-column: 1 / -1;
        }
    }

}
</style>